<template>
  <div>
    <div>
      <div id="network-page">
        <!-- <profile-header></profile-header> -->
        <div class="page-container">
          <div class="row">
            <div class="col-md-3 col-sm-4">
              <accordion title="Connections">
                <div
                  class="item"
                  v-ripple
                  @click="viewUserProfile(getConnectionInfo(connection).id)"
                  v-for="(connection,index) in connections.connections"
                  :key="index"
                >
                  <img
                    v-if="getConnectionInfo(connection).profile_picture"
                    class="profile"
                    :src="$fullUrl('images/profiles/'+getConnectionInfo(connection).profile_picture)"
                    alt="Profile picture"
                  />
                  <img v-else class="profile" src="../assets/avatar.png" alt />
                  <span
                    class="name"
                  >{{getConnectionInfo(connection).first_name.toUpperCase()+" "+getConnectionInfo(connection).last_name | validate }}</span>
                </div>
              </accordion>
              <accordion title="Companies">
                <!--<div class="item">
                            <img class="profile" src="../assets/avatar.png" alt="">
                            <span class="name">Jean Baptiste</span>
                </div>-->
              </accordion>
            </div>
            <div class="col-md-6 col-sm-8">
              <div class="invitations">
                <div class="header">
                  <div
                    class="title"
                  >{{(invitations.length>0)?"New invitations":"No new invitations" | validate }}</div>
                  <div class="actions">
                    <!--<a v-ripple class="btn btn-link" href="" @click.prevent="">Manage All</a>-->
                  </div>
                </div>
                <div class="body">
                  <div class="invitee" v-for="(invitation,index) in invitations" :key="index">
                    <div class="info">
                      <img
                        v-if="invitation.inviter.profile_picture"
                        class="profile-img"
                        :src="$fullUrl('images/profiles/'+invitation.inviter.profile_picture)"
                        alt="Profile picture"
                      />
                      <img v-else class="profile-img" src="../assets/avatar.png" alt />
                      <div class="details">
                        <span
                          class="names"
                        >{{invitation.inviter.first_name.toUpperCase()+" "+invitation.inviter.last_name | validate }}</span>
                        <!--<small>Designer at SB Studios</small>-->
                        <small>{{invitation.inviter.email | validate }}</small>
                      </div>
                    </div>
                    <div class="actions">
                      <button
                        v-ripple
                        class="btn-ignore"
                        @click="ignoreConnection(invitation.id,index)"
                      >Ignore</button>
                      <button
                        v-ripple
                        class="btn-accept"
                        @click="acceptConnection(invitation.id,index)"
                      >Accept</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="section-recommendations">
                <div class="title">Recommended for you</div>
                <div class="body">
                  <div class="tabs">
                    <div class="tabs-header">
                      <div class="tab active" id="tab1">People</div>
                      <div class="tab" id="tab2">Groups</div>
                      <div class="tab" id="tab3">Hash Tags</div>
                    </div>
                    <div class="tabs-body">
                      <div class="tab-content active" data-tab="tab1">
                        <div class="recommendations">
                          <div
                            class="recommendation"
                            v-for="(recommendation,index) in recommendations"
                          >
                            <div class="header">
                              <div class="bg"></div>
                              <img
                                v-if="recommendation.profile_picture"
                                class="profile-img"
                                :src="$fullUrl('images/profiles/'+recommendation.profile_picture)"
                                alt="Profile picture"
                              />
                              <img v-else class="profile-img" src="../assets/avatar.png" alt />
                            </div>
                            <div class="body">
                              <div
                                class="names"
                              >{{recommendation.first_name+" "+recommendation.last_name | validate }}</div>
                              <small class="career">{{recommendation.email | validate }}</small>
                              <small class="tot-connections">0 mutual connection</small>
                              <button
                                v-ripple
                                class="btn-connect"
                                @click="connectWith(recommendation.id,index)"
                              >Connect</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-content" data-tab="tab2">Tab 2</div>
                      <div class="tab-content" data-tab="tab3">Tab3</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-4">
              <accordion title="Groups">
                <div class="item">
                  <img class="profile" src="../assets/avatar.png" alt />
                  <span class="name">Programmers</span>
                </div>
                <div class="item">
                  <img class="profile" src="../assets/avatar.png" alt />
                  <span class="name">Web designers</span>
                </div>
                <div class="item">
                  <img class="profile" src="../assets/avatar.png" alt />
                  <span class="name">Developers</span>
                </div>
              </accordion>
              <!--<accordion title="Hashtags">
                        <div class="item">
                            <img class="profile" src="../assets/avatar.png" alt="">
                            <span class="name">Jean Baptiste</span>
                        </div>
                        <div class="item">
                            <img class="profile" src="../assets/avatar.png" alt="">
                            <span class="name">Jean Baptiste</span>
                        </div>
                        <div class="item">
                            <img class="profile" src="../assets/avatar.png" alt="">
                            <span class="name">Jean Baptiste</span>
                        </div>
              </accordion>-->
            </div>
          </div>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</template>

<script>
import Vroot from "@/views/Root";
import Accordion from "../components/Accordion2";
import ProfileHeader from "../components/Partials/ProfileHeader";
import Footer from "../components/Partials/Footer";
import { mapGetters } from "vuex";

export default {
  name: "network",
  components: {
    Accordion,
    ProfileHeader,
    appFooter: Footer,
    Vroot
  },
  mounted() {
    let tabs = document.querySelectorAll(".tabs .tab");
    let tabsContents = document.querySelectorAll(".tabs .tab-content");
    tabs.forEach(function(tab) {
      tab.addEventListener("click", function(evt) {
        let targetEl = evt.srcElement;
        //first remove the active class
        let t = document.querySelector(".tabs .tab.active");
        t.classList.remove("active");
        let content = document.querySelector(".tabs .tab-content.active");
        content.classList.remove("active");
        // console.log(evt.srcElement.id)
        targetEl.classList.add("active");
        let targetContent = document.querySelector(
          '.tabs .tab-content[data-tab="' + targetEl.id + '"]'
        );
        targetContent.classList.add("active");
      });
    });
  },
  created() {
    let vm = this;
    vm.getConnections();
    vm.getRecommendations();
    vm.getInvitations();
  },
  data() {
    return {
      connections: [],
      recommendations: [],
      invitations: []
    };
  },
  computed: {
    ...mapGetters(["getHelper"])
  },
  methods: {
    getConnections() {
      let vm = this;
      vm.$startLoader();
      vm.$http
        .get(vm.$fullUrl(this.getHelper.api.relativeUrls.getConnections), {
          headers: { Authorization: "Bearer " + sessionStorage.authToken }
        })
        .then(function(response) {
          vm.connections = response.data;
        })
        .catch(error => {
          // vm.loadError = true
          alert("An error occurred. Loading initial data failed. ");
        })
        .finally(() => {
          vm.$stopLoader();
        });
    },
    getRecommendations() {
      let vm = this;
      vm.$startLoader();
      vm.$http
        .get(vm.$fullUrl(this.getHelper.api.relativeUrls.getRecommendations), {
          headers: { Authorization: "Bearer " + sessionStorage.authToken }
        })
        .then(function(response) {
          vm.recommendations = response.data;
        })
        .catch(error => {
          // vm.loadError = true
          alert("An error occurred. Loading initial data failed. ");
        })
        .finally(() => {
          vm.$stopLoader();
        });
    },
    getInvitations() {
      let vm = this;
      vm.$startLoader();
      vm.$http
        .get(vm.$fullUrl(this.getHelper.api.relativeUrls.getInvitations), {
          headers: { Authorization: "Bearer " + sessionStorage.authToken }
        })
        .then(function(response) {
          vm.invitations = response.data;
        })
        .catch(error => {
          alert("An error occurred. Loading initial data failed. ");
        })
        .finally(() => {
          vm.$stopLoader();
        });
    },
    connectWith(id, index) {
      let vm = this;
      vm.$startLoader();
      vm.$http
        .post(
          vm.$fullUrl(this.getHelper.api.relativeUrls.postConnect),
          {
            id: id
          },
          {
            headers: { Authorization: "Bearer " + sessionStorage.authToken }
          }
        )
        .then(function(response) {
          // alert("Successfully connected")
          vm.recommendations.splice(index, 1);
        })
        .catch(error => {
          alert("An error occurred while trying to complete your request. ");
        })
        .finally(() => {
          vm.$stopLoader();
        });
    },
    acceptConnection(id, index) {
      let vm = this;
      vm.$startLoader();
      vm.$http
        .post(
          vm.$fullUrl(this.getHelper.api.relativeUrls.postAcceptConnection),
          {
            status: "accepted",
            id: id
          },
          {
            headers: { Authorization: "Bearer " + sessionStorage.authToken }
          }
        )
        .then(function(response) {
          // alert("Successfully accepted connection")
          vm.invitations.splice(index, 1);
          vm.getConnections();
        })
        .catch(error => {
          // vm.loadError = true
          alert("An error occurred while trying to complete your request. ");
        })
        .finally(() => {
          vm.$stopLoader();
        });
    },
    ignoreConnection(id, index) {
      let vm = this;
      vm.$startLoader();
      vm.$http
        .post(
          vm.$fullUrl(this.getHelper.api.relativeUrls.postIgnoreConnection),
          {
            status: "accepted",
            id: id
          },
          {
            headers: { Authorization: "Bearer " + sessionStorage.authToken }
          }
        )
        .then(function(response) {
          // alert("Successfully accepted connection")
          vm.invitations.splice(index, 1);
        })
        .catch(error => {
          // vm.loadError = true
          alert("An error occurred while trying to complete your request. ");
        })
        .finally(() => {
          vm.$stopLoader();
        });
    },
    getConnectionInfo(obj) {
      if (this.connections.user === obj.invitee.id) return obj.inviter;
      else return obj.invitee;
    },
    viewUserProfile(id) {
      this.$router.push({ name: "connection-profile", params: { id: id } });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/main";
@import "../styles/tabs-2";

#network-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.page-container {
  background-color: $grey-light;
  padding: 32px $pad-sides;
  flex-grow: 1;
  @media (max-width: 600px) {
    padding: 16px 8px;
  }
  @media (min-width: 600px) and (max-width: 960px) {
    padding: 32px 24px;
  }
}

.item {
  cursor: pointer;
  margin-top: 8px;
  padding: 8px;
  &:first-child {
    margin-top: 0;
  }
  &:hover {
    background-color: $black-1;
  }
  .profile {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .name {
    margin-left: 16px;
  }
}

.invitations {
  background-color: white;
  border: 1px solid $black-1;
  .header {
    display: flex;
    flex-direction: row;
    padding: 8px 16px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $black-1;
  }
  .invitee {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .info {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px;
      .profile-img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .details {
        margin-left: 8px;
        .names,
        small {
          display: block;
        }
        .names {
          font-size: 18px;
        }
        small {
          font-size: 12px;
        }
      }
    }
    .actions {
      padding: 8px;
      button {
        background-color: transparent;
        border: none;
        outline: none;
        font-size: 15px;
        color: $orange;
        &:hover {
          color: $black;
        }
        &.btn-ignore {
        }
        &.btn-accept {
          border: 1px solid $black-1;
          border-radius: 4px;
          padding-left: 16px;
          padding-right: 16px;
          margin-left: 16px;
        }
      }
    }
  }
}

.section-recommendations {
  padding: 8px 0;
  border: 1px solid $black-1;
  margin-top: 8px;
  background-color: white;
  .title {
    padding: 0 16px;
  }
  .recommendations {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    overflow: hidden;
    @media (max-width: 960px) {
      //Mobile and medium tablet
      flex-direction: column;
      flex-wrap: nowrap;
    }
  }
  .recommendation {
    width: 180px;
    border: 1px solid $black-1;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 8px;
    @media (max-width: 960px) {
      //Mobile and medium tablet
      width: auto;
    }
    .header {
      position: relative;
      height: 80px;
      .bg {
        height: 50px;
        background: $yellow-orange-y-grad;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
      }
      .profile-img {
        width: 64px;
        position: absolute;
        top: 16px;
        left: calc(50% - 32px);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      }
    }
    .body {
      padding: 8px;
      .names {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        margin-top: 8px;
      }
      .career {
        display: block;
        text-align: center;
        color: $black-5;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
      }
      .tot-connections {
        font-size: 11px;
        display: block;
        text-align: center;
        margin-top: 24px;
      }
      .btn-connect {
        background-color: transparent;
        border: 1px solid $orange;
        outline: none;
        padding: 4px 16px;
        width: 100%;
        color: $orange;
        border-radius: 8px;
        margin-top: 8px;
      }
    }
  }
}

.btn-link {
  color: $black;
}
</style>